/*jslint eqeq: true, nomen: true, plusplus: true, unparam: true, todo: true, vars: true, browser: true, indent: 3, maxerr: 50 */

/**
 * Control the Surrounding area map rendering
 * @param map  an instance of BingMaps.Map
 */
define(['jquery', 'c21/ajax', 'c21/track', 'c21/maps', 'bing', 'c21/maps/PinData', 'c21/Params', 'c21/internationalization', 'c21/ImageCache', 'binginfobox'], function ($, ajax, track, C21Maps, BingMaps, PinData, Params, internationalization, ImageCache)  {
   "use strict";

   return function (llMap, map, surroundingAreasTooltipManager, surroundingAreasMapping) {
      var m_polygonlayer = new BingMaps.Layer(),
         m_locationpinlayer = new BingMaps.Layer(),
         m_jSurroundingAreas = null,

         m_aShapes = [],
         m_oShapeByLocation = {},

         m_polygonStates = {
            hover: 1,
            selected: 2,
            primary: 3
         },

         m_polygonColor = {
            1: "#3A7479",
            2: "#5F5544",
            3: "#000000"
         },

         m_pinByLid = {},
         self = this,
         m_iCounter = 0,
         m_map = map,
         m_jBingMaps,

         m_aPins = [],

         m_iOldZoom = 0,

         SEARCH_TYPE = {
            PROPERTIES: 0,
            OFFICES: 1,
            AGENTS: 2
         },

         m_imageCache,
         m_imgPlus,
         m_imgEx,
         initializeAnimator = function () {
            m_imageCache = new ImageCache();
            m_imgPlus = m_imageCache.add("/images/eco/surroundingarea/plus.png");
            m_imgEx = m_imageCache.add("/images/eco/surroundingarea/ex.png");
            m_imageCache.load();
         },

         /**
          * Javascript implementation of algorithm detailed at:
          * http://stackoverflow.com/questions/3265986/an-algorithm-to-space-out-overlapping-rectangles
          *
          * @param aRects
          * @param iBorder
          */
         spaceOverlappingRectangles = function (aRects, iBorder) {
            var
               /**
                * Get the norm of an array
                * @param a  the array
                */
               normArray = function (a) {
                  var total = 0;

                  for (var i = a.length; i--;) {
                     total += Math.abs(a[i]) ^ 2;
                  }

                  return Math.sqrt(total);
               },

               /**
                * First level flatten array
                * @param a  the array to flatten
                * @return the array with all the first level items moved to the base level
                */
               flattenArray = function (a, i) {
                  var b = [];
                  for (var j = a.length; j--;) {
                     b = b.concat(a[j]);
                  }
                  return b;
               },

               /**
                * Dot product, only for 2x2 matrix and 2d vector
                * @param m  the rotation matrix (Format: [[a, b], [c, d]])
                * @param v  the vector (Format: [x, y])
                * @return resulting dot product... [ax + by, cx + dy]
                */
               customDotProduct = function (m, v) {
                  return [
                     (m[0][0] * v[0]) + (m[0][1] * v[1]),
                     (m[1][0] * v[0]) + (m[1][1] * v[1])
                  ];
               },

               /**
                * Get a 2d rotation matrix
                * @param angle  the angle of the matrix
                * @return the rotation matrix
                */
               rotationMatrix = function (angle) {
                  return [
                     [Math.cos(angle), -Math.sin(angle)],
                     [Math.sin(angle), Math.cos(angle)]
                  ];
               },

               minX = function (l, i) {
                  return l[i][0][0];
               },
               maxX = function (l, i) {
                  return l[i][0][1];
               },
               minY = function (l, i) {
                  return l[i][1][0];
               },
               maxY = function (l, i) {
                  return l[i][1][1];
               },
               payload = function (l, i) {
                  return l[i][2];
               },

               /**
                * Number of Intersects for a Rectangle
                * @param l  the list
                * @param i  index
                */
               countIntersects = function (l, i) {
                  // Except for itself
                  var iIntersects = -1,
                     iA = l[i],
                     iX = iA[0],
                     iY = iA[1];

                  for (var j = l.length; j--;) {
                     var jA = l[j],
                        jX = jA[0],
                        jY = jA[1];

                     if (
                        (Math.max(iX[0], jX[0]) < Math.min(iX[1], jX[1])) &&
                        (Math.max(iY[0], jY[0]) < Math.min(iY[1], jY[1]))
                     ) {
                        iIntersects++;
                     }
                  }

                  return iIntersects;
               },

               /**
                * countIntersectsR
                * @param l  the list
                * @param r  rectangle
                */
               countIntersectsR = function (l, r) {
                  var iIntersects = -1,
                     iX = r[0],
                     iY = r[1];

                  for (var j = l.length; j--;) {
                     var jA = l[j],
                        jX = jA[0],
                        jY = jA[1];

                     if (
                        (Math.max(iX[0], jX[0]) < Math.min(iX[1], jX[1])) &&
                        (Math.max(iY[0], jY[0]) < Math.min(iY[1], jY[1]))
                     ) {
                        iIntersects++;
                     }
                  }

                  return iIntersects;
               },

               /**
                * Get the most intersections of any rectangle
                * @return {Number}
                */
               findMaxIntesections = function (l) {
                  var iMax = 0,
                     iCurrent = 0;

                  for (var i = l.length; i--;) {
                     iCurrent = countIntersects(l, i);
                     iMax = Math.max(iCurrent, iMax);
                  }

                  return iMax;
               },

               /**
                * rectCenter
                * Get the center of a rectangle
                */
               rectCenter = function (l, i) {
                  return [
                     1 / 2 * maxX(l, i) + minX(l, i),
                     1 / 2 * maxY(l, i) + minY(l, i)
                  ];
               },

               /**
                * Get the geometric center
                */
               geometryCenter = function (l) {
                  var iSumX = 0,
                     iSumY = 0,
                     point;

                  for (var i = 0; i < l.length; i++) {
                     point = rectCenter(l, i);
                     iSumX += point[0];
                     iSumY += point[1];
                  }

                  return [
                     iSumX / l.length,
                     iSumY / l.length
                  ];
               },

               /**
                * Increment or decrement the size of all reactangles by a bit
                * (put/remove borders)
                * @param l        the list of rectangles
                * @param iBorder  amount to increment
                * @return new list of rectangles
                */
               changeSize = function (l, iBorder) {
                  var a = [];

                  for (var i = l.length; i--;) {
                     a.push([
                        [minX(l, i) - iBorder, maxX(l, i) + iBorder],
                        [minY(l, i) - iBorder, maxY(l, i) + iBorder],
                        payload(l, i)
                     ]);
                  }

                  return a;
               },

               /**
                * sortListByIntersections
                */
               sortListByIntersections = function (l) {
                  /* Order list by ost intersecting Rects */
                  var a = [];
                  for (var j = l.length; j--;) {
                     a.push([countIntersectsR(l, l[j]), j]);
                  }

                  var b = a.sort(function (a, b) {
                     return b[0] - a[0];
                  });

                  var aReturn = [];
                  for (var i = 0; i < b.length; i++) {
                     aReturn.push(
                        l[
                           // Index from a
                           b[i][1]
                           ]
                     );
                  }

                  return aReturn;
               },

               /**
                * calcPos
                */
               calcPos = function (angle, displacement, length, origin) {
                  var matrix = window.g_matrixTmpCache[angle];

                  if (!matrix) {
                     matrix = window.g_matrixTmpCache[angle] = rotationMatrix(angle);
                  }

                  var displace = customDotProduct(matrix, displacement),
                     x = length * displace[0],
                     y = length * displace[1],

                     origin0 = origin[0],
                     origin1 = origin[1];

                  return [
                     [origin0[0] + x, origin0[1] + x],
                     [origin1[0] + y, origin1[1] + y],
                     origin[2]
                  ];
               },

               // Create a copy of the array, with modified sizes (so borders do not touch)
               aRects = changeSize(aRects, iBorder),

               aWorkList = [],

               iCheckInterval = Math.PI / 12,
               iCheckMax = Math.PI / 4;

            window.g_matrixTmpCache = {};

            // Weed out rectangles that have too many intersections
            while (findMaxIntesections(aRects) > 0) {
               // Find the rectangles with the most intersections
               aRects = sortListByIntersections(aRects);

               // Prepend the worst offender to the "work" list
               aWorkList.unshift(aRects[0]);

               // Remove it from the good rectangle list
               aRects.splice(0, 1);
            }

            // When there are only good rectangles (no intersections) left,
            // move the worst rectangles
            while (aWorkList.length != 0) {
               var vectorCenter = geometryCenter(aRects);

               // Give a preference to axis, as imposed by geometric symmetry
               var vectorToMove = rectCenter(aWorkList, 0);
               vectorToMove[0] -= vectorCenter[0];
               vectorToMove[1] -= vectorCenter[1];

               var toCheckPreserve = flattenArray(aWorkList.slice(0, 1));

               aWorkList.splice(0, 1);

               var iMoveAttempts = 1,
                  iMoveBorder = iBorder;

               var toCheck = toCheckPreserve;

               while (countIntersectsR(aRects, toCheck) != -1) {
                  for (var j = 0; j < iCheckMax; j += iCheckInterval) {
                     toCheck = calcPos(j, vectorToMove, iMoveBorder, toCheckPreserve);

                     if (countIntersectsR(aRects, toCheck) == -1) break;

                     toCheck = calcPos(-j, vectorToMove, iMoveBorder, toCheckPreserve);

                     if (countIntersectsR(aRects, toCheck) == -1) break;

                     toCheck = calcPos(Math.PI + j, vectorToMove, iMoveBorder, toCheckPreserve);

                     if (countIntersectsR(aRects, toCheck) == -1) break;

                     toCheck = calcPos(Math.PI - j, vectorToMove, iMoveBorder, toCheckPreserve);

                     if (countIntersectsR(aRects, toCheck) == -1) break;
                  }

                  iMoveAttempts++;
                  iMoveBorder = iMoveAttempts * iBorder;
               }
               ;

               // Push element to front of aRects
               aRects.unshift(toCheck);
            }

            // Restore original sizes
            return changeSize(aRects, -iBorder);
         },

         spaceAreas = function () {
            var aRects = [];
            // For every entity

            $.each(m_pinByLid, function (strLid, pinInfo) {
               // Get x, y pixel location
               // Get height & width
               var halfWidth = pinInfo.width / 2,
                  halfHeight = pinInfo.height / 2,

                  loc = new BingMaps.Location(pinInfo.lat, pinInfo.lon),
                  point = m_map.tryLocationToPixel(loc, BingMaps.PixelReference.control),
                  x = point.x,
                  y = point.y;

               aRects.push([
                  [-halfWidth + x, halfWidth + x],
                  [-halfHeight + y, halfHeight + y],
                  {
                     pin: pinInfo.rawPin,
                     halfWidth: halfWidth,
                     halfHeight: halfHeight
                  }
               ]);
            });

            var aSpacedRects = spaceOverlappingRectangles(aRects, 0.05);

            $.each(aSpacedRects, function (i, a) {
               var minX = a[0][0],
                  minY = a[1][0],
                  maxX = a[0][1],
                  maxY = a[1][1],
                  entity = a[2],

                  point = new BingMaps.Point(minX + entity.halfWidth, minY + entity.halfHeight),
                  loc = m_map.tryPixelToLocation(point, BingMaps.PixelReference.control);

               if (point != null) {
                  entity.pin.setLocation(loc);
                  //entity.pin.ShowInfoBox();
               } else {
                  console.debug('got null for', point.x, point.y);
               }
            });
         },

         initialize = function () {
            // Breaks display of polygons in the layer in V8
            //m_polygonlayer.setZIndex(1);

            m_locationpinlayer.setZIndex(2);
            m_map.layers.insert(m_polygonlayer);
            m_map.layers.insert(m_locationpinlayer);

            m_jBingMaps = $("#bingMap");
            initializeAnimator();

            var bChanged = false;
            BingMaps.Events.addHandler(m_map, "viewchangeend", function () {
               var iNewZoom = m_map.getZoom();
               if (iNewZoom != m_iOldZoom) {
                  bChanged = true;
                  m_iOldZoom = iNewZoom;

                  setTimeout(function () {
                     spaceAreas();
                  }, 50);
               }
            });
         };

      /**
       * Draws a rounded rectangle using the current state of the canvas.
       * If you omit the last three params, it will draw a rectangle
       * outline with a 5 pixel border radius
       * @param {CanvasRenderingContext2D} ctx
       * @param {Number} x The top left x coordinate
       * @param {Number} y The top left y coordinate
       * @param {Number} width The width of the rectangle
       * @param {Number} height The height of the rectangle
       * @param {Number} [radius = 5] The corner radius; It can also be an object
       *                 to specify different radii for corners
       * @param {Number} [radius.tl = 0] Top left
       * @param {Number} [radius.tr = 0] Top right
       * @param {Number} [radius.br = 0] Bottom right
       * @param {Number} [radius.bl = 0] Bottom left
       * @param {Boolean} [fill = false] Whether to fill the rectangle.
       * @param {Boolean} [stroke = true] Whether to stroke the rectangle.
       */
      function roundRect(ctx, x, y, width, height, radius, fill, stroke) {
         if (typeof stroke == 'undefined') {
            stroke = true;
         }
         if (typeof radius === 'undefined') {
            radius = 5;
         }
         if (typeof radius === 'number') {
            radius = {
               tl: radius,
               tr: radius,
               br: radius,
               bl: radius
            };
         } else {
            var defaultRadius = {
               tl: 0,
               tr: 0,
               br: 0,
               bl: 0
            };
            for (var side in defaultRadius) {
               radius[side] = radius[side] || defaultRadius[side];
            }
         }
         ctx.beginPath();
         ctx.moveTo(x + radius.tl, y);
         ctx.lineTo(x + width - radius.tr, y);
         ctx.quadraticCurveTo(x + width, y, x + width, y + radius.tr);
         ctx.lineTo(x + width, y + height - radius.br);
         ctx.quadraticCurveTo(x + width, y + height, x + width - radius.br, y + height);
         ctx.lineTo(x + radius.bl, y + height);
         ctx.quadraticCurveTo(x, y + height, x, y + height - radius.bl);
         ctx.lineTo(x, y + radius.tl);
         ctx.quadraticCurveTo(x, y, x + radius.tl, y);
         ctx.closePath();
         if (fill) {
            ctx.fill();
         }
         if (stroke) {
            ctx.stroke();
         }
      }

      function step(ctx, x, y, degree, iTotalDegrees, w) {
         var hw = w / 2;

         ctx.save();

         ctx.setTransform(1, 0, 0, 1, x, y);

         // Clear the canvas
         ctx.clearRect(0, 0, w, w);

         ctx.translate(hw, hw);
         ctx.rotate(-degree * Math.PI / 180);

         ctx.drawImage(m_imgPlus.img, -hw, -hw);

         ctx.rotate(-degree * Math.PI / 180);
         ctx.globalAlpha = degree / iTotalDegrees;
         ctx.drawImage(m_imgEx.img, -hw, -hw);

         ctx.restore();
      };

      function renderSurroundingAreaPin(text, number, type, hover, selected, primary) {
         var c = document.createElement('canvas'),
            ctx = c.getContext('2d'),
            textHeight = 12,
            fontAreaName = "bold " + textHeight.toString() + "px Arial";

         var fontExtraText = "12px Arial";
         var fontNumText = "15px Arial";

         ctx.font = fontAreaName;
         var upperText = text.toUpperCase();
         var textSize = ctx.measureText(upperText);
         var lineWidth = 5;
         var paddingX = 10;
         var paddingY = 6;
         var borderRadius = 11;

         var iconWidth = 17;
         var width = textSize.width + (2 * (paddingX + lineWidth));
         if (!primary) {
            width += paddingX + iconWidth;
         }

         var text1 = internationalization.getString('Add') + " " + number.toString();
         var text2 = internationalization.getString(type);
         ctx.font = fontExtraText;
         var textWidth1 = ctx.measureText(text1).width;
         var textWidth2 = ctx.measureText(text2).width;
         ctx.font = fontNumText;
         var textWidthNum = ctx.measureText(number.toString()).width;
         var extraWidth = 0;
         if (hover) {
            extraWidth = Math.max(textWidth1, textWidth2, textWidthNum) + paddingX + paddingX;
         }
         var height = textHeight + (2 * (paddingY + lineWidth)) + 2;
         var baseColor = (primary) ? '#000' : ((selected) ? '#5F5544' : '#3a7479');

         c.width = width + extraWidth;
         c.height = height;
         c.style.width = width + 'px';
         c.style.height = height + 'px';

         if (hover || selected || primary) {
            ctx.strokeStyle = baseColor;
            ctx.fillStyle = baseColor;
            ctx.lineWidth = lineWidth;
            roundRect(ctx, 5, lineWidth / 2, width + extraWidth - lineWidth - 5, height - lineWidth, borderRadius, true, true);
         }

         var space = extraWidth - lineWidth;
         if (selected || primary) {
            // Text
            ctx.fillStyle = '#fff';
            ctx.font = fontNumText;
            var textStartNum = (space - textWidthNum) / 2;
            ctx.fillText(number.toString(), width + textStartNum, paddingY + lineWidth + 12);
         } else if (hover) {
            var textStart1 = (space - textWidth1) / 2;
            var textStart2 = (space - textWidth2) / 2;

            // Text
            ctx.fillStyle = '#fff';
            ctx.font = fontExtraText;

            ctx.fillText(text1, width + textStart1, paddingY + lineWidth + 5);
            ctx.fillText(text2, width + textStart2, paddingY + lineWidth + 18);
         }

         ctx.fillStyle = '#fff';
         ctx.strokeStyle = baseColor;
         ctx.lineWidth = lineWidth;
         roundRect(ctx, lineWidth / 2, lineWidth / 2, width - lineWidth - 1, height - lineWidth, borderRadius, true, true);

         // Text
         ctx.fillStyle = baseColor;
         ctx.font = fontAreaName;
         ctx.fillText(upperText, paddingX + lineWidth, paddingY + lineWidth + textHeight);

         if (!primary) {
            step(ctx, lineWidth + paddingX + textSize.width + paddingX, 9, (selected) ? 180 : 0, 180, iconWidth);
         }

         return {
            url: c.toDataURL(),
            width: width,
            height: height
         };
      }

      initialize();

      /**
       * Add the surrounding area pin to the map
       * @param area  the area info (displayName, lid, etc)
       * @param loc   the lat/lon coordinates
       */
      this.addSurroundingAreaPin = function (area, loc) {
         m_iCounter++;

         var strSearchType = $("#lqSearchType").val(),
            iSearchType = SEARCH_TYPE[strSearchType],
            areaSearchType = $("#surroundingAreaSearchType").val(),
            strTypeDisplay = "",
            retParameter = "",
            bPrimary = (area.location == surroundingAreasMapping.getPrimaryAreaLocation()),
            bSelected = surroundingAreasMapping.isAreaSelected(area.lid),
            strCountType;

         switch (iSearchType) {
            case SEARCH_TYPE.PROPERTIES:
               retParameter = "pid";
               strTypeDisplay = "Properties";
               strCountType = "propertycount";
               break;

            case SEARCH_TYPE.OFFICES:
               retParameter = "oid";
               strTypeDisplay = "Offices";
               strCountType = "officecount";
               break;

            default:
            case SEARCH_TYPE.AGENTS:
               retParameter = "aid";
               strTypeDisplay = "Agents";
               strCountType = "agentcount";
               break;
         }

         // Get the area display name
         var strDisplayName = area.displayName;
         if (areaSearchType == 'Neighborhood' && strDisplayName.length > 0) {
            // If its a neighborhood then, the display name must not have city/state
            var areaDisplayArray = strDisplayName.split(",");
            if (areaDisplayArray != null && areaDisplayArray.length > 0) {
               strDisplayName = areaDisplayArray[0];
            }
         }

         // Create an info box
         var locationCount = 0;
         var originalPinSize = getPinOptions();
         var pin = new BingMaps.Pushpin(loc, $.extend({
            zIndex: C21Maps.getZindexFromLoc(
               loc.latitude,
               loc.longitude
            ),
         }, originalPinSize));

         function getPinOptions() {
            var pinRendered = renderSurroundingAreaPin(strDisplayName, locationCount, strTypeDisplay, bHover, bSelected, bPrimary);
            return {
               icon: pinRendered.url,
               width: pinRendered.width,
               height: pinRendered.height,
               anchor: new BingMaps.Point(pinRendered.width / 2, pinRendered.height / 2),
            };
         }

         function renderPin() {
            pin.setOptions(getPinOptions());
         }

         m_aPins.push(pin);
         m_locationpinlayer.add(pin);

         var bAjaxRequestInProgress = false,
            bHover = false,

            updateAreasOnMap = function () {
               area = surroundingAreasMapping.getSurroundingArea(area.location);
               locationCount = area[strCountType];
               renderPin();
            },

            updatePolygon = function (bVisible) {
               if (bPrimary) return;
               self.setPolygonsVisible(area, bVisible);
            },

            enableHover = function () {
               bHover = true;
               bAjaxRequestInProgress = true;
               renderPin();

               // Retrieve the current search parameters
               var params = ajax.getParameters();
               var deltalid = params.lid; //primary area
               params.sa = "";
               params.s = "";
               params.rpp = "";
               params.ret = retParameter;
               params.zoom = 18;
               params.bounds = 1;
               params.lid = area.lid;
               params.t = iSearchType;

               // Deltalid parameter: list of primary and selected locations
               var selectedAreas = surroundingAreasMapping.getSelectedSurroundingAreas(); //other selected areas
               if (selectedAreas && selectedAreas.length > 0) {
                  deltalid = deltalid + "," + selectedAreas;
               }
               // Deltalid parameter must not have the lid parameter value for which the counts are being retrieved.
               if (deltalid) {
                  if (deltalid.indexOf(params.lid + ",") != -1) {
                     deltalid = deltalid.replace(params.lid + ",", "");
                  } else if (deltalid.indexOf("," + params.lid) != -1) {
                     deltalid = deltalid.replace("," + params.lid, "");
                  } else {
                     deltalid = deltalid.replace(params.lid, "");
                  }
               }
               params.deltalid = deltalid;

               // Using a unique subview so calls don't inturrupt each other
               ajax.doViewEngineAjax(area.lid, "/searchcounts/", $.param(params), {
                  cache: true,
                  callback: function() {
                     bAjaxRequestInProgress = false;
                     updateAreasOnMap();
                     updatePolygon(bHover);
                  }
               });
            },
            disableHover = function () {
               bHover = false;
               renderPin();
               if (!bAjaxRequestInProgress) {
                  updatePolygon(false);
               }
            },

            doHover = function (bHover) {
               if (bSelected) {
                  return;
               }

               if (bHover) {
                  enableHover();
               } else {
                  disableHover();
               }
            },

            enableCheck = function () {
               bSelected = true;
               enableHover();
            },
            disableCheck = function () {
               bSelected = false;
               updateAreasOnMap();
               updatePolygon(true);
            },

            doCheck = function (bChecked) {
               if (bChecked) {
                  enableCheck();
               } else {
                  disableCheck();
               }
            };

         if (bPrimary) {
            self.addLocationPolygons(surroundingAreasMapping.getPrimaryArea(), m_polygonStates.primary);
            enableHover();
         } else {
            if (bSelected) {
               enableCheck();
            }

            BingMaps.Events.addHandler(pin, 'mouseover', function () {
               m_pinByLid[area.lid].doHover(true);
               surroundingAreasMapping.addHoverSurroundingAreaCheckbox(area.lid);
            });

            BingMaps.Events.addHandler(pin, 'mouseout', function () {
               m_pinByLid[area.lid].doHover(false);
               surroundingAreasMapping.removeHoverSurroundingAreaCheckbox(area.lid);
            });

            BingMaps.Events.addHandler(pin, 'click', function () {
               // Add the polygon for this selected location and also select it in the modal
               var bChecked = surroundingAreasMapping.toggleSelectedSurroundingArea(area.lid);
               m_pinByLid[area.lid].doCheck(bChecked);
            });
         }

         return {
            doCheck: doCheck,
            doHover: doHover,
            lat: area.lat,
            lon: area.lon,
            height: originalPinSize.height,
            width: originalPinSize.width,
            rawPin: pin
         };
      };

      /**
       * Draw a polygon to the map with the specified coordinates and color
       * @param aLocation
       * @param polygonColor
       */
      this.addPolygon = function (aLocation, polygonState, strLocationName) {
         var poly = new BingMaps.Polygon(aLocation, self.getPolygonOptions(polygonState));

         // Add the shape to the map
         m_polygonlayer.add(poly);
         m_aShapes.push(poly);
         m_oShapeByLocation[strLocationName].push(poly);
      };

      this.getPolygonOptions = function (polygonState) {
         if (polygonState) {
            var fillOpa = 0.3,
               polygonColor = m_polygonColor[polygonState],
               polygonFillColor = new Microsoft.Maps.Color.fromHex(polygonColor);

            polygonFillColor.a = fillOpa;

            return {
               fillColor: polygonFillColor,
               strokeColor: new BingMaps.Color(0, 0, 0, 0),
               strokeThickness: 0
            };
         } else {
            return {
               visible: false
            };
         }
      };

      /**
       * Clear the surrounding areas pins and polygon layers
       *
       */
      this.clearSurroundingAreas = function () {
         m_polygonlayer.clear();
         m_iCounter = 0;

         m_aShapes = [];
         m_oShapeByLocation = {};
         $.each(m_aShapes, function (i, shape) {
            m_polygonlayer.remove(shape);
         });

         m_aPins = [];
         m_locationpinlayer.clear();

         if (m_jSurroundingAreas == null) {
            m_jSurroundingAreas = $("<div id='surroundingAreasOverlay' style='position: absolute; left: 0; top: 0;'></div>");
            m_jBingMaps.append(m_jSurroundingAreas);
         } else {
            m_jSurroundingAreas.empty();
         }

         m_pinByLid = {};
      };

      this.createPins = function () {
         var aAreas = surroundingAreasMapping.getSurroundingAreas(),
            aSelectedAreas = surroundingAreasMapping.getSelectedSurroundingAreas(),
            aLoc = [];

         $.each(aAreas, function (i, area) {
            var strLid = area.lid,
               loc = new BingMaps.Location(area.lat, area.lon);

            m_pinByLid[strLid] = self.addSurroundingAreaPin(area, loc);
            aLoc.push(loc);
         });

         $.each(aSelectedAreas, function (i, strLid) {
            m_pinByLid[strLid].doCheck(true);
         });

         llMap.setViewFromLocations(aLoc);
         //llMap.modifyZoom(-1);
      };

      /**
       * Clear and render the area pins and the polygon layers
       *
       */
      this.render = function () {
         self.clearSurroundingAreas();
         self.createPins();
         spaceAreas();
      };

      this.setPolygonsVisible = function (area, bVisible) {
         var aShapes = m_oShapeByLocation[area.location],
            strLid = area.lid,
            bAreaSelected = surroundingAreasMapping.isAreaSelected(strLid),
            state = (bVisible) ? (bAreaSelected) ? m_polygonStates.selected : m_polygonStates.hover : false;

         if (aShapes) {
            var options = self.getPolygonOptions(state);
            options.visible = bVisible;

            $.each(aShapes, function (i, poly) {
               poly.setOptions(options);
            });
         } else {
            self.addLocationPolygons(area, state);
         }
      };

      /**
       * Draw the location polygon
       */
      this.addLocationPolygons = function (area, polygonState) {
         m_oShapeByLocation[area.location] = [];

         // For each polygon
         $.each(area.polygons, function (i, polygon) {
            // This would be the pretty way of doing it
            var aPoints = polygon.split("|"),
               aLocation = [];

            // For each set of points
            $.each(aPoints, function (i, strPoint) {
               var aPointParts = strPoint.split(","),
                  strLatitude = aPointParts[1],
                  strLongitude = aPointParts[0],
                  fLatitude = parseFloat(strLatitude),
                  fLongitude = parseFloat(strLongitude),
                  loc = new BingMaps.Location(fLatitude, fLongitude);

               aLocation.push(loc);
            });

            self.addPolygon(aLocation, polygonState, area.location);
         });
      }

      /**
       * Check State
       */
      this.setChecked = function (id, bChecked) {
         m_pinByLid[id].doCheck(bChecked);
      };

      /**
       * Hover State
       */
      this.setHover = function (id, bHover) {
         m_pinByLid[id].doHover(bHover);
      };
   };
});
